export const environment = {
  production: true,
  config: {
    api: {
      baseURL: 'https://backend.icilalune.com',
    },
  },
};
